import { useObserver } from 'mobx-react-lite';

import useUser from 'src/hooks/use-user';
import { PersonalizedProductsQuery } from 'src/personalization/data-layer/types';
import { PersonalizedProductsModelNames } from 'src/gql/graphql';
import { usePersonalizationEnabled } from 'src/utils/personalization/hooks/use-personalization-enabled';
import { usePersonalizedItemsV2 } from 'src/recommendations/use-personalized-items-v2';

type UseProductsForHomePageParams = {
  dispensaryId: string;
};

export type UseProductsForHomePageReturn = {
  personalizedProductsQuery: PersonalizedProductsQuery;
};

export function useProductsForHomePage({ dispensaryId }: UseProductsForHomePageParams): UseProductsForHomePageReturn {
  const user = useUser();
  const isLoggedIn = useObserver(() => user.isLoggedIn);
  const isPersonalizationEnabledForHomePage = usePersonalizationEnabled();

  const personalizedProductLimit = isLoggedIn ? 20 : 3;

  const { data, loading, error } = usePersonalizedItemsV2(
    () => Promise.resolve([]),
    [], // No product context
    PersonalizedProductsModelNames.recommendedForYou,
    {
      limit: personalizedProductLimit,
      skip: !dispensaryId || !isPersonalizationEnabledForHomePage,
    }
  );

  // Transform V2 data to match V1 interface for backward compatibility
  const transformedData = data
    ? {
        getPersonalizedProducts: {
          products: data,
        },
      }
    : undefined;

  return {
    personalizedProductsQuery: {
      data: transformedData,
      loading,
      error: error as any, // V2 returns Error, V1 expects ApolloError - cast for compatibility
    },
  };
}
